import React from 'react';

import {Group} from '@pb/kit-component-group';
import Loading, {Types} from '@pb/kit-component-loading';

import type {Error as ApiError} from 'src/openapi/admin/models/Error';

type Props = {name: string, loading: boolean, error?: ApiError};

export const ProductColumnHeader = ({name, loading, error}: Props) => (
    <Group alignItems="center" gap="s">
        {loading ? <Loading type={Types.ICON}/> : null}
        {error ? (
            <span
                role="img"
                aria-label={error.message || 'Failed to load product access'}
                title={error.message || 'Failed to load product access'}>⚠
            </span>
        ) : null}
        <strong>{name}</strong>
    </Group>
);
